import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import StackedHeadings from '../components/StackedHeadings';
import Services from '../components/Services';
import ProcessSection from '../components/ProcessSection';
import Testimonial from '../components/Testimonial';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div>
      <Navbar transparent />
      <Hero />
      <StackedHeadings
        prefix="Why Caprock"
        phrases={['On-Time', 'Every Load', 'Every Mile']}
        description="From dispatch to delivery, Caprock is built to move freight the way it should be moved — fast, safe, and accountable."
      />
      <Services />
      <StackedHeadings
        dark
        prefix="The Old Way"
        phrases={['The Industry Is', 'delayed', 'unreliable', 'opaque']}
        description="Missed windows. Silent dispatch. Freight that shows up whenever. Caprock was built to be the opposite of all of it."
      />
      <StackedHeadings
        prefix="The Caprock Way"
        phrases={['What You Get With Us', 'on-time', 'transparent', 'accountable']}
        description="Real people, moving your freight with real accountability."
      />
      <ProcessSection />
      <Testimonial />
      <CTA />
      <Footer />
    </div>
  );
};

export default Home;
